import { useTenantStore } from "../../stores/tenant/use-tenant-store";
import { IVICustomerRegistrationCompleted } from "./Versions/IVICustomerRegistrationCompleted";

import { PartnerConfig, FluxoType } from "../../stores/tenant/tenant.types";
import { IVISellerRegistrationCompleted } from "./Versions/IVISellerRegistrationCompleted";

const RegistrationCompleted = () => {
  const { type, brand } = useTenantStore();

  const DEFAULT_VERSION = {
    [FluxoType.CONSULTOR]: <IVISellerRegistrationCompleted />,
    [FluxoType.AUTOSSERVICO]: <IVICustomerRegistrationCompleted />,
    [FluxoType.INDICACAO]: <IVICustomerRegistrationCompleted />,
  };

  const versions: Record<PartnerConfig, Record<FluxoType, JSX.Element | null>> = {
    DEFAULT: DEFAULT_VERSION,
    BENUP: DEFAULT_VERSION,
  };

  return type ? versions[brand][type] : null;
};

export default RegistrationCompleted;
